import React, { PropsWithChildren, useMemo } from 'react'
import { I18nextProvider } from 'react-i18next'

import { createI18nInstance } from '../../i18n'

type Props = PropsWithChildren<{ language?: string }>

export const I18nProvider = ({ language, children }: Props) => {
  const i18n = useMemo(() => createI18nInstance(language), [language])

  return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
}
